import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import PropTypes from 'prop-types';
import metadata from './PUPHouseholdDriverComponent.metadata.json5';
import messages from './PUPHouseholdDriverComponent.messages';

function PUPHouseholdDriverComponent(props) {
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        value: driverVM,
        index,
        id,
        path,
        onValueChange,
        onValidate,
        showValidationErrors,
        isDriver
    } = props;

    const {
        onValidate: setComponentValidation,
        isComponentValid
    } = useValidation(id);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const writeValue = useCallback((value, changedPath) => {
        onValueChange(value, `${path}.${changedPath}`);
    }, [onValueChange, path]);

    const nameSuffixTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
    const getPersonName = () => {
        if (driverVM.value && driverVM.contact.value) {
            const contactValue = driverVM.contact.value;
            return contactValue.getFullName(nameSuffixTypeList, translator);
        }
        return '';
    };

    const overrideProps = {
        householdDriverx: {
            content: translator(messages.householdDriverx, { householdMemberNumber: (index + 1) })
        },
        householdDriverName: {
            content: getPersonName()
        },
        householdAgeFirstLicensedRowContainer: {
            visible: isDriver(driverVM)
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            model={driverVM}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
        />
    );
}

PUPHouseholdDriverComponent.propTypes = {
    value: PropTypes.shape({}).isRequired,
    id: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    path: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool,
    isDriver: PropTypes.func.isRequired
};

PUPHouseholdDriverComponent.defaultProps = {
    showValidationErrors: false
};

export default PUPHouseholdDriverComponent;
